// extracted by mini-css-extract-plugin
export var dropdownButton = "_3r-0";
export var fullWidthDropdownButton = "_3r-1";
export var icon = "_3r-3";
export var iconPlaceholder = "_3r-2";
export var menuItemRow = "_3r-5";
export var shortcutContainer = "_3r-4";